module.exports = __webpack_public_path__ + "img/step04_c_stand_basic_right_screws.7bef7ddb.png";